var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#fff" } },
    [
      _c("van-nav-bar", { attrs: { title: "换码" } }),
      _vm._v(" "),
      _c("van-cell", {
        staticStyle: { "text-align": "left" },
        attrs: { center: "", title: "自动补充新码" },
        scopedSlots: _vm._u([
          {
            key: "right-icon",
            fn: function() {
              return [
                _c("van-switch", {
                  attrs: { size: "24" },
                  model: {
                    value: _vm.checked,
                    callback: function($$v) {
                      _vm.checked = $$v
                    },
                    expression: "checked"
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _vm.checked
        ? [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "12px",
                  "text-align": "left",
                  color: "#9c0003",
                  padding: "0 15px"
                }
              },
              [
                _vm._v(
                  "开启自动识别后，将按照顺序自动填充新码（需要先扫描两组号码,以识别是递增或递减）"
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { padding: "20px" } },
        [
          _c(
            "ul",
            { staticClass: "card-list" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.iccid1, function(item, index) {
                return _c("li", { staticClass: "card-item" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { "text-align": "left", "min-width": "40px" }
                    },
                    [_vm._v(_vm._s(index + 1))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "100%", display: "flex" } },
                    [
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _vm._v(" " + _vm._s(item))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _vm._v(_vm._s(_vm.short_number1[index]))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "del",
                      staticStyle: {
                        width: "20%",
                        "text-align": "right",
                        color: "#1fe66a"
                      }
                    },
                    [_vm._v("成功")]
                  )
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.iccid, function(item, index) {
                return _c("li", { staticClass: "card-item" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { "text-align": "left", "min-width": "40px" }
                    },
                    [_vm._v(_vm._s(index + 1))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { width: "100%", display: "flex" } },
                    [
                      _c("div", { staticStyle: { width: "100%" } }, [
                        _vm._v(" " + _vm._s(item))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%", color: "#3a8ee6" } },
                        [_vm._v(_vm._s(_vm.short_number[index]))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "del",
                      staticStyle: { width: "20%", "text-align": "right" },
                      on: {
                        click: function($event) {
                          return _vm.remove(index)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                ])
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-row",
            [
              _c("van-cell", [
                _vm.wxReady == true
                  ? _c(
                      "div",
                      [
                        _c(
                          "van-button",
                          {
                            attrs: { type: "primary", block: "", icon: "qr" },
                            on: { click: _vm.handleScan }
                          },
                          [_vm._v("扫码")]
                        )
                      ],
                      1
                    )
                  : _c(
                      "p",
                      {
                        staticStyle: {
                          "font-size": "14px",
                          color: "#ff5257",
                          "line-height": "100px",
                          "text-align": "center"
                        }
                      },
                      [_vm._v("请等待扫码组件加载完成")]
                    )
              ]),
              _vm._v(" "),
              _c(
                "van-cell",
                [
                  _vm.iccid.length > 0
                    ? _c(
                        "van-button",
                        {
                          attrs: { type: "info", block: "", icon: "upgrade" },
                          on: { click: _vm.handleSubmit }
                        },
                        [_vm._v("提交绑定\n                ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "card-item" }, [
      _c(
        "div",
        { staticStyle: { "text-align": "left", "min-width": "40px" } },
        [_vm._v("序号")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            display: "flex",
            "text-align": "center"
          }
        },
        [
          _c("div", { staticStyle: { width: "100%" } }, [_vm._v(" 旧码")]),
          _vm._v(" "),
          _c("div", { staticStyle: { width: "100%" } }, [_vm._v("新码")])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { width: "20%", "text-align": "right" } }, [
        _vm._v("操作")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37aacca1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../app/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37aacca1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../app/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changecode.vue
// module id = null
// module chunks = 